module.exports = __webpack_public_path__ + "static/hyperv_51.d2bc7d60.png";